import React, { useEffect, useState, useMemo, useRef } from "react";
import api from "../../api";
import { debug } from "../../utils";
import { applyConditionalDisplay } from "./utils/applyConditionalDisplay";
import { BsCheckLg } from "react-icons/bs";
import RenderTabs from "./partials/RenderTabs";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import './assets/form-builder-render.css';
export default function FormBuilderRender({
  src = null,
  externalSchema = null,
  meta,
  onSave,
  onTabChange,
  onChange,
  onCtrlBlur,
  onValidate,
  saveSignal,
  isCompleted = false,
  isReadOnly = false,
  formDataInitial = {},
  validationErrors = {},
  analysis = {},
  topButtons,
  bottomsButtons = [],
  statusInfo,
}) {
  const [schema, setSchema] = useState(null);
  const formData = formDataInitial || {};
  const [loading, setLoading] = useState(true);
  const [isDirty, setIsDirty] = useState(false);
  // 👉 INDEX BRUT
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [tabStatus, setTabStatus] = useState({});
  const isHistoryNavigation = useRef(false);
  const lastPushedTab = useRef(0);
  const setDeep = (obj, path, value) => {
    const parts = path.split(".");
    const last = parts.pop();
    const target = parts.reduce((acc, key) => {
      if (!acc[key] || typeof acc[key] !== "object") {
        acc[key] = {};
      }
      return acc[key];
    }, obj);
    target[last] = value;
  };
  useEffect(() => {
    const handlePopState = (event) => {
      return
      const state = event.state;
      if (!state || typeof state.tab !== "number") return;
      // isHistoryNavigation.current = true;
      setActiveTabIndex(state.tab);
    };
    const params = new URLSearchParams(window.location.search);
    const tabFromUrl = parseInt(params.get("tab"), 10);
    const initialTab = !isNaN(tabFromUrl) ? tabFromUrl : 0;
    // ✅ On enrichit l'entrée courante SANS changer l'URL
    // Ça préserve l'entrée "dashboard" derrière dans l'historique
    /*
    window.history.replaceState(
      { ...window.history.state, tab: initialTab },
      ""
    );
    lastPushedTab.current = initialTab;
*/
    if (initialTab !== 0) {
      // isHistoryNavigation.current = true;
      setActiveTabIndex(initialTab);
    }
    //window.addEventListener("popstate", handlePopState);
    return () => {
      //window.removeEventListener("popstate", handlePopState);
    }
  }, []);
  useEffect(() => {
    if (saveSignal) {
      setIsDirty(false);
    }
  }, [saveSignal]);
  const handleChange = (path, value) => {
    const updated = structuredClone(formData);
    setDeep(updated, path, value);
    onChange?.(updated);
    setIsDirty(true);
  };
  const handleClickSave = () => onSave?.(formData);
  const handleClickValidate = () => onValidate?.(formData);
  useEffect(() => {
    if (externalSchema) {
      setSchema(externalSchema);
      setLoading(false);
      return;
    }
    if (!src) {
      setSchema(null);
      setLoading(false);
      return;
    }
    const load = async () => {
      try {
        api.handleError = false;
        const res = await api.get("/formbuilder/format?src=" + src);
        if (res?.data?.format) {
          setSchema(res.data.format);
        }
      } catch (e) {
        console.error("Erreur chargement format :", e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [src, externalSchema]);
  const visibleSchema = useMemo(() => {
    if (!schema) return null;
    return applyConditionalDisplay(schema, formData);
  }, [schema, formData]);
  const tabs = useMemo(() => {
    if (!visibleSchema?.properties) return [];
    return Object.keys(visibleSchema.properties);
  }, [visibleSchema]);
  // 👉 SAFE INDEX
  const safeTabIndex =
    activeTabIndex < 0
      ? 0
      : activeTabIndex >= tabs.length
        ? tabs.length - 1
        : activeTabIndex;
  const activeTab = tabs[safeTabIndex] || null;
  // 👉 REMONTÉE AU PARENT (INDEX BRUT)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
    if (isHistoryNavigation.current) {
      isHistoryNavigation.current = false;
      // On met quand même à jour lastPushedTab pour rester cohérent
      lastPushedTab.current = activeTabIndex;
      onTabChange?.({ formData, tabsLength: tabs.length, activeTab, activeTabIndex, safeTabIndex, isDirty });
      return;
    }
    onTabChange?.({ formData, tabsLength: tabs.length, activeTab, activeTabIndex, safeTabIndex, isDirty });
  }, [activeTabIndex]);


  const slideNav = (sens) => {
    let next = Math.max(0, Math.min(activeTabIndex + sens, tabs.length));
    setActiveTabIndex(next);
    onTabChange?.({ formData, tabsLength: tabs.length, activeTab, activeTabIndex: next, safeTabIndex, isDirty });

  }

  const analysisTabMap = useMemo(() => {
    const map = {};
    Object.entries(analysis || {}).forEach(([tabKey, fields]) => {
      let hasRejected = false;
      Object.values(fields || {}).forEach(fieldAnalysis => {
        if (fieldAnalysis?.status === "rejected") {
          hasRejected = true;
        }
      });
      map[tabKey] = { hasRejected };
    });
    return map;
  }, [analysis]);
  useEffect(() => {
    if (!tabs.length) return;
    const next = {};
    tabs.forEach(tabKey => {
      if (analysisTabMap?.[tabKey]?.hasRejected) {
        next[tabKey] = "invalid";
        return;
      }
      if (!validationErrors) {
        next[tabKey] = "neutral";
        return;
      }
      if (Object.keys(validationErrors).length === 0) {
        next[tabKey] = "valid";
        return;
      }
      if (validationErrors[tabKey]) {
        next[tabKey] = "invalid";
      } else {
        next[tabKey] = "valid";
      }
    });
    setTabStatus(next);
  }, [analysisTabMap, validationErrors, tabs]);
  const totalSteps = tabs.length;
  const currentStep = safeTabIndex + 1;
  const progressPercent = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;
  const hasData = Object.keys(formData || {}).length > 0;
  const canValidate =
    hasData &&
    !isDirty &&
    (validationErrors && Object.keys(validationErrors).length === 0) &&
    isReadOnly === false;
  if (loading) return <div>Chargement du formulaire...</div>;
  if (!schema) return <div>Aucun schéma trouvé.</div>;
  return (
    <div>
      <form className="formbuilder-render pb-5 mb-5">
        {/* SAVE BAR */}
        <div className="fb-savebar mb-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="col-md-3"></div>
            <div className="col-md-9 d-flex justify-content-between gap-3 align-items-start">
              <div className="flex-grow-1 me-3 text-center">
                {isReadOnly ? (
                  <div className="text-danger">
                    Ce formulaire est en lecture seule.
                  </div>
                ) : (
                  !canValidate && totalSteps > 1 && (
                    <div className="fb-progress-line">
                      <div
                        className="fb-progress-fill"
                        style={{ width: progressPercent + "%" }}
                      />
                    </div>
                  )
                )}
                {statusInfo?.visible && (
                  <div
                    className={`fb-status-info text-${statusInfo.className || ''}`}
                    dangerouslySetInnerHTML={{ __html: statusInfo.content || '' }}
                  />
                )}
              </div>
              <div className="fb-actions d-flex flex-grow-0 gap-3">
                {!isReadOnly &&
                  topButtons?.filter(btn => btn?.visible).map((btn, index) => (
                    <button
                      key={index}
                      type="button"
                      className={`btn px-4 rounded-pill ${btn.className || "btn-primary"}`}
                      style={{ width: "130px" }}
                      disabled={btn.disabled || false}
                      onClick={() => btn.onClick?.(formData)}
                    >
                      {btn.label ?? "Enregistrer"}
                    </button>
                  ))}
              </div>
            </div>
          </div>
        </div>
        {/* TABS */}
        <RenderTabs
          schema={visibleSchema}
          formData={formData}
          onChange={handleChange}
          onCtrlBlur={onCtrlBlur}
          isReadOnly={isReadOnly}
          meta={meta}
          activeTab={activeTab}
          setActiveTab={(tabKey) => {
            const idx = tabs.indexOf(tabKey);
            if (idx !== -1) setActiveTabIndex(idx);
          }}
          validationErrors={validationErrors}
          analysis={analysis}
        />
        {/* NAV */}
        {totalSteps > 1 && (
          <div className="fb-bottom-bar fixed-bottom">
            <div className="container d-flex justify-content-between align-items-center py-2 px-4 gap-3">
              {/* PREV */}
              <button
                className="btn btn-outline-secondary rounded-pill"
                type="button"
                disabled={safeTabIndex <= 0}
                onClick={() => { slideNav(-1); }}
              >
                <span className="d-none d-lg-inline">Précédent</span>
                <span className="d-lg-none"><FiChevronLeft size={20} /></span>
              </button>
              {/* PINS */}
              <div className="d-none d-lg-inline">
                <div className="fb-nav-pins d-flex gap-2 justify-content-center flex-grow-1">
                  {tabs.map((t, idx) => {
                    const status = tabStatus[t] || "neutral";
                    const isActive = idx === safeTabIndex;
                    return (
                      <div
                        key={t}
                        onClick={() => setActiveTabIndex(idx)}
                        className={`fb-nav-pin ${status} ${isActive ? "active" : ""}`}
                      >
                        <span className="fb-nav-pin-number">{idx + 1}</span>
                        {(status === "valid" || status === "invalid") && (
                          <BsCheckLg className={`fb-nav-pin-check-icon ${status}`} />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* MOBILE */}
              <div className="d-lg-none px-3 text-nowrap">
                {safeTabIndex + 1} / {tabs.length}
              </div>
              {/* NEXT */}
              <button
                type="button"
                className={`btn rounded-pill btn-primary`}
                disabled={false && Object.keys(validationErrors).length > 0 && activeTabIndex === tabs.length - 1}
                onClick={() => { slideNav(+1); }}
              >
                <span className="d-none d-lg-inline">Suivant</span>
                <span className="d-lg-none"><FiChevronRight size={20} /></span>
              </button>

            </div>

          </div>
        )}
      </form>

    </div>
  );
}